import {Observable} from 'rxjs';
import {filter}     from 'rxjs/operators';

import SyntheticMediaEventType from '../Constants/SyntheticMediaEventType';
import IMediaEventsStreamPayload from '../Interfaces/IMediaEventsStreamPayload';

const createCueChangeStream = (
    mediaEvents$: Observable<IMediaEventsStreamPayload>
): Observable<IMediaEventsStreamPayload> =>
    mediaEvents$
        .pipe(
            filter(mediaEvent => mediaEvent.type === SyntheticMediaEventType.CUE_CHANGE)
        );

export default createCueChangeStream;